import {all, call, put, select, takeLatest} from 'redux-saga/effects'
import types from '../actions/types'
import {
  emailingContactListPostFailure,
  emailingContactListPostSuccess,
  emailingContactPostFailure,
  emailingContactPostSuccess,
  emailingOpportunityPostFailure,
  emailingOpportunityPostSuccess,
} from 'actions/emailing'
import {getMergeFieldsParams} from 'helpers/integrations/mailchimp'
import {loadContact} from 'actions/contacts'
import {isViewCompanyDialogVisible} from 'selectors/dialog'
import {hidePostContactDialog, viewCompanyDialogContactLoad} from 'actions/dialog'
import {getHubspotStatus} from 'selectors/integrations'
import {getHubSpotDealDeepLinkUrl} from 'helpers/integrations/hubspot'
import {openUrlInNewTab} from 'helpers/url'
import {isNil, get} from 'lodash'
import {reloadOpportunityOnBoard} from 'actions/opportunities'
import {snackbarMessage} from 'actions/snackbar'
import {iconNames} from 'components/icon'
import {getEmailingIntegrationName} from 'helpers/emailing'

export default (api) => {

  function* contactListPost({ listId, contactListId, emailingIntegration, mergeFields}) {
    try {
      const params = {
        listId,
        contactListId,
        emailingIntegration,
        mergeFields: getMergeFieldsParams(mergeFields),
      }
      const response = yield call(api.emailing.contactListPost, params)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(emailingContactListPostSuccess(data.result))
          },
          function* onFail(key, message, code) {
            yield put(emailingContactListPostFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
    }
  }

  function* contactPost({contactId, emailingIntegration, mergeFields}) {
    try {

      const params = {
        contactId,
        emailingIntegration,
        mergeFields: getMergeFieldsParams(mergeFields),
      }

      const response = yield call(api.emailing.contactPost, params)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            const contactId = data.result
            const isViewCompanyDialogShowing = yield select(isViewCompanyDialogVisible)
            if (isViewCompanyDialogShowing) {
              yield put(viewCompanyDialogContactLoad(contactId))
            } else {
              yield put(loadContact(contactId))
            }
            yield put(emailingContactPostSuccess(contactId))
            yield put(hidePostContactDialog())
          },
          function* onFail(key, message, code) {
            yield put(emailingContactPostFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
    }
  }

  function* opportunityPost({opportunityId, emailingIntegration}) {
    try {

      const params = {
        opportunityId,
        emailingIntegration,
      }

      const emailingIntegrationName = getEmailingIntegrationName(emailingIntegration)
      yield put(snackbarMessage(`Posting Opportunity to ${emailingIntegrationName}`, iconNames.loading, false, false))
      const response = yield call(api.emailing.opportunityPost, params)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            const hubspotStatus = yield select(getHubspotStatus)
            const portalId = get(hubspotStatus, 'portalId', null)

            const result = data.result[0]
            const hubspotDealId = get(result, 'hubspotDealMapping.dealId', null)
            const opportunity = get(result, 'opportunity', null)

            yield put(snackbarMessage(`Your opportunity was posted to ${emailingIntegrationName}`, iconNames.tick, true))
            yield put(emailingOpportunityPostSuccess(result))
            yield put(reloadOpportunityOnBoard(opportunity))

              if (!isNil(hubspotDealId)) {
                  openUrlInNewTab(getHubSpotDealDeepLinkUrl(portalId, hubspotDealId))
              } else {
                  yield put(snackbarMessage(`Something went wrong while posting your opportunity to ${emailingIntegrationName}`, iconNames.error))
              }
          },
          function* onFail(key, message, code) {
            yield put(emailingOpportunityPostFailure(message, code))
            yield put(snackbarMessage(message, iconNames.error))
          }
      )
    } catch (e) {
      console.error(e)
    }
  }

  function * watcher () {
    yield all([
      takeLatest(types.EMAILING_CONTACT_LIST_POST_ATTEMPT, contactListPost),
      takeLatest(types.EMAILING_CONTACT_POST_ATTEMPT, contactPost),
      takeLatest(types.EMAILING_OPPORTUNITY_POST_ATTEMPT, opportunityPost),
    ])
  }

  return {
    watcher,
  }
}
